<template>
  <v-sheet>
    <v-container class="wrap-container">
      <v-app-bar app color="white" elevation="0">
        <v-spacer></v-spacer>
        <v-btn icon color="black" @click="BACK_FUNC">
          <v-icon>mdi-close-circle</v-icon>
        </v-btn>
      </v-app-bar>
      <flipbook
        class="flipbook"
        :pages="fetch_list"
        v-slot="flipbook"
        :startPage="pageNum"
        @filp-left-start="FLIP_LEFT_START"
        @flip-left-end="FLIP_LEFT_END"
        @flip-right-start="FLIP_RIGHT_START"
        @flip-right-end="FLIP_RIGHT_END"
      >
        <div class="action-bar">
          <v-btn icon @click="flipbook.flipLeft">
            <v-icon :color="flipbook.canFlipLeft ? 'black' : 'grey3'">
              mdi-arrow-left-circle
            </v-icon>
          </v-btn>
          <v-btn icon @click="flipbook.zoomIn">
            <v-icon :color="flipbook.canZoomIn ? 'black' : 'grey3'">
              mdi-plus-circle
            </v-icon>
          </v-btn>

          <span>
            Page {{ flipbook.page }} of {{ flipbook.numPages }}
          </span>

          <v-btn icon @click="flipbook.zoomOut">
            <v-icon :color="flipbook.canZoomOut ? 'black' : 'grey3'">
              mdi-minus-circle
            </v-icon>
          </v-btn>
          <v-btn icon @click="flipbook.flipRight">
            <v-icon :color="flipbook.canFlipRight ? 'black' : 'grey3'">
              mdi-arrow-right-circle
            </v-icon>
          </v-btn>
        </div>
      </flipbook>
    </v-container>
  </v-sheet>
</template>

<script>
import Flipbook from "flipbook-vue";
import CommonMixin from "@/config/commonFunc";

export default {
  name: "CatalogView",
  components: {
    Flipbook,
  },
  mixins: [CommonMixin],
  data: () => ({
    app_type: "homepage",
    page_type: "ecatalog",
    action: "catalog_view",
    include_file: "view",
    array_name: "data_list",
    infiniteId: +new Date(),
    fetch_list: [],
    pageNum: null,
  }),

  mounted() {
    this.FETCH_DATA(this.$route.params.seq);
    window.addEventListener("hashchange", (page) => {
      this.SET_PAGE_FROM_HASH(page);
    });
  },
  methods: {
    BACK_FUNC: function () {
      this.$MOVE_FUNC("CatalogList");
    },
    FETCH_DATA: function (seq) {
      this.fetch_list = [];
      // const url = "https://emons.co.kr/upload_files";
      const url = "https://images.emons.co.kr/brand/upload_files";
      const payload = {
        array_name: this.array_name,
        app_type: this.app_type,
        include_file: this.include_file,
        page_type: this.page_type,
        action: this.action,
        seq: seq,
      };
      this.AC_PUT_FETCH_DATA(payload).then((res) => {
        res.data[this.array_name].forEach((element) => {
          this.fetch_list.push(
            url + element.FILE_PATH + element.FILE_SAVE
          );
        });
      });
    },
    FLIP_LEFT_START: function (page) {
      console.log("FLIP_LEFT_START", page);
    },
    FLIP_LEFT_END: function (page) {
      console.log("FLIP_LEFT_END", page);
      // window.location.hash = "#" + page;
      this.pageNum = page;
    },
    FLIP_RIGHT_START: function (page) {
      console.log("FLIP_RIGHT_START", page);
    },
    FLIP_RIGHT_END: function (page) {
      console.log("FLIP_LEFT_START", page);
      this.pageNum = page;
      // window.location.hash = "#" + page;
    },
    SET_PAGE_FROM_HASH: function () {
      let n = parseInt(window.location.hash.slice(1), 10);
      if (isFinite) {
        this.pageNum = n;
      }
    },
  },
};
</script>
<style scope>
.wrap-container {
  margin: 0 auto;
  overflow: hidden;
}
.action-bar {
  width: 100%;
  height: 30px;
  padding: 10px 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.flipbook {
  width: 100vw;
  height: calc(90vh - 90px);
  //background-color: #14008c;
}
.disabled {
  color: #000;
  pointer-events: none;
}
.credit {
  font-size: 12px;
  line-height: 20px;
  margin: 10px;
}
</style>
